<script>
  import page from 'page';
  import theme from './theme.js';
  import Terms from './pages/Terms.svelte';
  import Main from './pages/Main.svelte';
  import BadBrowser from './pages/BadBrowser.svelte';
  import Admin from './pages/Admin/Admin.svelte';
  import _404 from './pages/_404.svelte';
  import config from './config.js';

  let component, props;

  // Routes
  page('/', () => setPage(Main));
  page('/bad-browser', () => setPage(BadBrowser));
  page('/terms', () => setPage(Terms));
  page('/:room', ({ params }) => setPage(Main, { roomFromUrl: params.room }));
  page('/admin/:room', ({ params }) => setPage(Admin, { room: params.room }));
  page('*', () => setPage(_404));
  page.start();

  // SNOWPACK: Hot Module Replacement for selected page
  if (config.debug.on && config.debug.page) {
    component = eval(config.debug.page);
  }

  function setPage(componentObj, propsObj) {
    component = componentObj;
    props = propsObj;
  }
</script>

<style type="text/postcss" global>
  @import './style/main.css';
</style>

<svelte:head>
  <title>{theme.name}</title>
  <link
    href="https://fonts.googleapis.com/css2?family=Nunito:wght@200;400;800&display=swap"
    rel="stylesheet" />
</svelte:head>

<div class="viewport">
  <svelte:component this="{component}" {...props} />
</div>
